export const transformAutocompleteAddressResponseToOptions = (data) =>
	data ? data.map((i) => ({ ...i, value: i.mergedAddress })) : []
